import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SettingFragment$data } from '../../package/src/graphql/__generated__/SettingFragment.graphql';
import { SETTING_GANT } from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterGantLoader } from '../store/slices/gantLoaderSlice';
import { setterGant } from '../store/slices/gantSlice';
import { ItemTaskType, LoaderDataType, ScheduleItemType, SettingGantDataType, SettingGantType } from '../types';

const useAfterLoader = () => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const dataScheduleItemFromServer = useSelector<RootState, LoaderDataType<ScheduleItemType>>(
        (state) => state.gantLoader.dataScheduleItemFromServer,
    );

    const dataSettingFromServer = useSelector<RootState, LoaderDataType<SettingFragment$data>>(
        (state) => state.gantLoader.dataSettingFromServer,
    );
    const mappingTaskByProject = useSelector<RootState, { [key: string]: ItemTaskType[] }>(
        (state) => state.gantLoader.mappingTaskByProject,
    );

    useEffect(() => {
        if (!Object.keys(mappingTaskByProject).length) {
            return;
        }

        dispatch(
            setterGantLoader({
                dataScheduleItemFromServer: {
                    ...dataScheduleItemFromServer,
                    rows: dataScheduleItemFromServer.rows.map((item) => ({
                        ...item,
                        tasks: mappingTaskByProject[item.id] || [],
                    })),
                },
            }),
        );
    }, [mappingTaskByProject]);

    useEffect(() => {
        const settingGant = dataSettingFromServer.rows.find((row) => row.name === SETTING_GANT);

        if (settingGant) {
            dispatch(
                setterGant({
                    settingGant: {
                        ...(settingGant as any as SettingGantType),
                        data: (settingGant?.data ? JSON.parse(settingGant?.data) : {}) as SettingGantDataType,
                    },
                    connectionSettingGant: dataSettingFromServer.connectionId,
                }),
            );
        }
    }, [dataSettingFromServer]);
};

export default useAfterLoader;
